/**
 * Determines if the current key is still valid (not expired)
 * @param {Object} state - Redux state
 * @returns {boolean} True if the key exists and is not expired
 */
export const selectIsKeyValid = (state) => {
  const expiresAt = state.patientGenerateKey.expires_at;

  if (!expiresAt) return false;

  const expiryTime = new Date(expiresAt);
  const currentTime = new Date();

  return currentTime < expiryTime;
};

/**
 * Gets the permission level of the current key
 * @param {Object} state - Redux state
 * @returns {string|null} 'view' or 'edit' or null if no key
 */
export const selectKeyPermission = (state) =>
  state.patientGenerateKey.permission;
